import { Injectable } from '@angular/core';
import { BaseService } from '@base/base.service';
import { Question } from '../models/question.model';

@Injectable()
export class QuestionsService extends BaseService<Question> {
  serviceUrl = '/api/questions';
}
